import { ConversationComponent } from './conversation.component';
import { AuthGuard } from '../../../../../common/services/Auth.guard';
import { EmailComponent } from './email/email.component';
import { LiveChatComponent } from './live-chat/live-chat.component';
import { FacebookComponent } from './facebook/facebook.component';
import { ZaloComponent } from './zalo/zalo.component';
import { SmsComponent } from './sms/sms.component';

export const ConversationSettingsRoute = [
  {
    path: 'channel',
    component: ConversationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'live-chat', pathMatch: 'full' },
      {
        path: 'live-chat',
        component: LiveChatComponent,
        canActivate: [AuthGuard],
      },
      { path: 'email', component: EmailComponent, canActivate: [AuthGuard] },
      {
        path: 'facebook',
        component: FacebookComponent,
        canActivate: [AuthGuard],
      },
      { path: 'zalo', component: ZaloComponent, canActivate: [AuthGuard] },
      { path: 'sms', component: SmsComponent, canActivate: [AuthGuard] },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/conversation.route.ts